export default "__VITE_ASSET__BrLA9NHs__"